<template>
  <div class="analysis-configuration-line">
    <div v-if="!loading" class="d-flex align-center">
      <mf-icon
        v-if="analysisConfiguration && analysisConfiguration.type"
        :fill="analysisConfiguration.type === 'RECURRENT'"
        :icon="analysisConfiguration.type === 'RECURRENT' ? 'source_notes' : 'article'"
        color="marca-0-l10"
        size="20"
      />
      <div class="ml-2">
        <h3>{{ analysisConfiguration && analysisConfiguration.title ? analysisConfiguration.title : '-' }}</h3>
        <p>{{ analysisConfiguration && analysisConfiguration.description ? analysisConfiguration.description : '-' }}</p>
      </div>
    </div>
    <mf-loading v-else loader-type="dynamic" :boolean-loader="loading" :dynamic-amount="1" />

    <div class="divider"></div>

    <div v-if="!loading" class="d-flex align-center justify-space-between">
      <ul>
        <li v-for="item in analysisConfigurationFilters" :key="item.icon">
          <mf-icon :icon="item.icon" size="18" fill color="marca-0-l10" />
          <span>{{ item.label }}</span>
        </li>
      </ul>

      <mf-icon v-if="!hideArrow" icon="expand_more" color="marca-0-l30" size="24" />
    </div>
    <mf-loading v-else loader-type="dynamic" :boolean-loader="loading" :dynamic-amount="1" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'AnalysisConfigurationLine',
  props: {
    analysisConfiguration: {
      type: Object,
      default: () => {},
    },
    hideArrow: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({}),
  computed: {
    ...mapGetters(['units']),
    analysisConfigurationFilters() {
      const selectedConfigurationFilters = [
        {
          label:
            this.analysisConfiguration.units === 1
              ? '1 Loja'
              : `${this.analysisConfiguration.units === this.units.length ? 'Todas as lojas' : this.analysisConfiguration.units + ' Lojas'}`,
          icon: 'store',
        },
      ]

      if (this.analysisConfiguration.personType) {
        selectedConfigurationFilters.push({
          label: this.analysisConfiguration.personType === 'LEGAL_PERSON' ? 'PJ' : 'PF',
          icon: 'groups',
        })
      }

      if (this.analysisConfiguration.products > 0) {
        selectedConfigurationFilters.push({
          label: this.analysisConfiguration.products === 1 ? '1 Produto' : `${this.analysisConfiguration.products} Produtos`,
          icon: 'sell',
        })
      }

      if (this.analysisConfiguration.offersScheduleIds > 0) {
        selectedConfigurationFilters.push({
          label: this.analysisConfiguration.offersScheduleIds === 1 ? '1 Oferta' : `${this.analysisConfiguration.offersScheduleIds} Ofertas`,
          icon: 'attach_money',
        })
      }

      return selectedConfigurationFilters
    },
  },
}
</script>

<style lang="scss" scoped>
.analysis-configuration-line {
  user-select: none;
  cursor: pointer;
  display: grid;
  grid-template-columns: 1fr 2px 1fr;
  align-items: center;
  gap: 12px;

  .divider {
    height: calc(100% - 12px);
    width: 2px;
    background-color: $marca-0-l10;
  }

  ul {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 0;

    li {
      display: flex;
      align-items: center;
      gap: 4px;

      span {
        color: $marca-0-l10;
        font-size: 14px;
      }
    }
  }

  h3 {
    font-weight: 700;
    color: $marca-0-l10;
    font-size: 14px;
    margin-bottom: 2px;
  }

  p {
    color: $cinza-d10;
    font-size: 12px;
    margin: 0;
  }
}
</style>
